import React, { memo } from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import { Login } from "../pages";
import { buildLoginPathWithOptionalSaml } from "../utils/azureAdLogout";

function PublicPages() {
  const loginPath = buildLoginPathWithOptionalSaml();

  return (
    <Switch>
      <Route path="/login">
        <Login />
      </Route>
      <Redirect to={loginPath} />
    </Switch>
  );
}

export default memo(PublicPages);
